/**
 * /table & /enjoy · shared fixed footer strip.
 * Quiet, translucent — sits below content, gives the page a frame.
 */
import React from "react";

export function TableFooter({ slug = "table", tagline = "Mira listens, humans deliver." }) {
    return (
        <footer
            data-testid="table-footer"
            className="fixed bottom-0 left-0 right-0 z-20"
            style={{
                background: "rgba(244, 239, 230, 0.86)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                borderTop: "1px solid var(--t-line)",
            }}
        >
            <div className="max-w-6xl mx-auto px-6 h-11 flex items-center justify-between">
                <span style={{ fontSize: 11.5, color: "var(--t-ink3)" }}>
                    <span className="t-serif" style={{ color: "var(--t-ink2)" }}>
                        /{slug}
                    </span>{" "}
                    — {tagline}
                </span>
                <span style={{ display: "flex", alignItems: "center", gap: 14 }}>
                    {/* Compliance attribution · Google Places TOS
                       requires one visible "powered by Google" line
                       per page when displaying Places content. We
                       keep it the smallest possible · members read
                       Concierge®, not Google, on every card. */}
                    <span
                        data-testid="powered-by-attribution"
                        style={{
                            fontSize: 9,
                            color: "var(--t-ink3)",
                            opacity: 0.55,
                            letterSpacing: "0.04em",
                        }}
                    >
                        live inventory powered by Google
                    </span>
                    <span
                        className="t-mono"
                        style={{ fontSize: 10, color: "var(--t-ink3)", letterSpacing: "0.1em" }}
                        title="Concierge® is a registered trademark"
                    >
                        Concierge® · a registered trademark · est. 1998
                    </span>
                    <a
                        href="/dreamweaver"
                        data-testid="footer-dreamweaver-link"
                        style={{
                            fontSize: 10,
                            color: "var(--t-brass, #8B6914)",
                            letterSpacing: "0.14em",
                            textDecoration: "none",
                            borderBottom: "1px dotted var(--t-brass, #8B6914)",
                            opacity: 0.9,
                            fontStyle: "italic",
                        }}
                        className="t-mono"
                        title="Whisper a dream"
                    >
                        Dreamweaver
                    </a>
                    <a
                        href="/terms"
                        data-testid="footer-terms-link"
                        style={{
                            fontSize: 10,
                            color: "var(--t-ink3)",
                            letterSpacing: "0.1em",
                            textDecoration: "none",
                            borderBottom: "1px dotted var(--t-line)",
                            opacity: 0.85,
                        }}
                        className="t-mono"
                    >
                        Terms
                    </a>
                    <a
                        href="/legal"
                        data-testid="footer-privacy-link"
                        style={{
                            fontSize: 10,
                            color: "var(--t-ink3)",
                            letterSpacing: "0.1em",
                            textDecoration: "none",
                            borderBottom: "1px dotted var(--t-line)",
                            opacity: 0.85,
                        }}
                        className="t-mono"
                    >
                        Privacy
                    </a>
                </span>
            </div>
        </footer>
    );
}
